<template>
    <div>
        <!-- 分类管理弹窗 -->
        <el-dialog title="检测词分类管理" :visible="dialog_visible" width="640px" custom-class="shop-group-manage-dialog"
            @close="handleClose">
            <div class="group_manage_toolbar">
                <el-button size="small" type="primary" @click="handleAdd">新增分类</el-button>
            </div>
            <div class="group_manage_body">
                <el-table :data="list" size="small" border:max-height="360">
                    <el-table-column prop="dictionary_name" label="检测词分类名称" min-width="180"></el-table-column>
                    <!-- <el-table-column prop="" label="分类类型" min-width="180"></el-table-column> -->
                    <el-table-column label="分类类型" prop="status" align="center" >
                        <template #default="{ row }">
                        <el-tag v-if="row.merchant_id===0" size="small">系统</el-tag>
                        <el-tag v-else size="small">自配</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-empty v-if="list.length === 0" description="暂无分类" :image-size="90"></el-empty>
            </div>
        </el-dialog>

        <!-- 新增/编辑分类弹窗 -->
        <el-dialog :title="formEdit ? '编辑检测词分类' : '新增检测词分类'" :visible.sync="formVisible" width="400px">
            <el-form :model="form" label-width="80px">
                <el-form-item label="分类类别" v-if="ismanager">
                    <el-radio v-model="is_system" :label="1">系统</el-radio>
                    <el-radio v-model="is_system" :label="2">自配</el-radio>
                </el-form-item>

                <el-form-item label="分类名称">
                    <el-input v-model="form.dictionary_name" maxlength="30" show-word-limit placeholder="请输入检测词分类名称"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="formVisible = false">取消</el-button>
                <el-button size="small" type="primary" :loading="submitLoading"
                    @click="submitOperate">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: 'DictionaryWordsManage',
    props: {
        // 控制组件显示/隐藏
        dialog_visible: {
            type: Boolean,
            default: false
        },
        // 分类列表（支持外部传入初始化）
        initList: {
            type: Array,
            default: () => []
        },
        dictionary_type:{
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            list:[],
            ismanager: false,
            formEdit: false,
            formVisible: false,
            submitLoading: false,
            form:{
                id:'',
                dictionary_name:''
            },
            is_system: 2,
        }
    },
    watch: {
        // 监听外部传入的可见状态，同步分类列表
        initList(newVal) {
            if (newVal) {
                this.list = this.ismanager ? [...this.initList] : this.initList.filter(item => item.merchant_id !== 0);
            }
        },
    },
    computed:{
        ...mapState({
            users:(state)=>state.login.userinfo
        })
    },
    created(){
        this.ismanager = this.users.mer_user_id === '1'
    },
    methods: {
        ...mapActions({
            opAddDictionaryWords: "ucenter/opAddDictionaryWords",
            opPutDictionaryWords: "ucenter/opPutDictionaryWords",
            opDeleteDictionaryWords: "ucenter/opDeleteDictionaryWords",
        }),
        // 关闭弹窗时通知父组件
        handleClose() {
            this.$emit('update:dialog_visible', false);
        },
        // 新增分类
        handleAdd() {
            this.form = { id: null, dictionary_name: ''};
            this.formEdit = false
            this.formVisible = true
        },
        // 编辑分类
        handleEdit(row) {
            this.form = { ...row };
            this.formEdit = true
            this.formVisible = true
        },
        // 删除分类
        handleDelete(row) {
            this.$confirm('确定要删除该分类吗？该分类下的所有关键词都会删除。', '提示', {
                type: 'warning'
            }).then(async () => {
                this.opDeleteDictionaryWords({
                    data: {'id':row.id, 'dictionary_type': this.dictionary_type},
                    success: (res) => {
                        if (res.code === 200) {
                            this.$message.success('删除成功');
                            this.$emit('dataChange'); // 通知父组件分类变化
                        } else {
                            this.$message.error(res.message || '删除失败');
                        }
                    }
                });

                // }
            }).catch(() => {
                this.$message.error(res.message || '删除异常');
            });
        },
        // 提交新增/编辑分类（需调用接口的话补充逻辑）
        submitOperate() {
            if (!this.form.dictionary_name) {
                return this.$message.warning('请输入分类名称');
            }
            this.submitLoading = true;
            let data = { 'dictionary_name': this.form.dictionary_name.trim(), 'dictionary_type': this.dictionary_type, 'is_system': this.is_system};
            try {
                const callback = (res, successMessage) => {
                    this.formVisible = false;
                    if (res.code === 200) {
                        this.$message.success(successMessage);
                        this.groupFormVisible = false;
                    } else {
                        this.$message.error(res.message || '操作失败');
                    }
                    this.$emit('dataChange'); // 通知父组件分类变化
                };
                if (!this.formEdit) {
                    this.opAddDictionaryWords({
                        data,
                        success: (res) => callback(res, '新增成功')
                    });
                } else {
                    data.id = this.form.id
                    this.opPutDictionaryWords({
                        data,
                        success: (res) => callback(res, '修改成功')
                    });
                }

                // }
            } catch (error) {
                console.log(error);

                this.$message.error('操作失败');
            } finally {
                this.submitLoading = false;
            }
        },
    }
}
</script>

<style scoped>
.group_manage_toolbar {
    margin-bottom: 15px;
}

.group_manage_body {
    padding: 0 5px;
}
</style>